var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.compatibleBrowser)?_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1):_c('div',[_vm._v(" Incompatible browser, please upgrade! ")])}
var staticRenderFns = []

export { render, staticRenderFns }